/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import Dropdown from '../../../components/dropdown';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  searchInput: string,
  searchType: number,
  setSearchInput: (string) => void,
  setFilter: (number | string) => void
};

const EventPageFilters = ({
  searchInput,
  searchType,
  setSearchInput,
  setFilter
}: PropsType): React.Element<typeof React.Fragment> => {
  const _context = React.useContext(DefaultContainerContext);
  const filters = [
    {
      label: 'All events',
      attr: {
        'data-id': 0
      },
      callback: () => {
        setFilter(0, 'type');
        _context.handleSetFilterEventDashboard([0, 'type']);
      }
    },
    {
      label: 'Upcoming events',
      attr: {
        'data-id': 1
      },
      callback: () => {
        setFilter(1, 'type');
        _context.handleSetFilterEventDashboard([1, 'type']);
      }
    },
    {
      label: 'Past events',
      attr: {
        'data-id': 2
      },
      callback: () => {
        setFilter(2, 'type');
        _context.handleSetFilterEventDashboard([2, 'type']);
      }
    },
    {
      label: 'Archived events',
      attr: {
        'data-id': 5
      },
      callback: () => {
        setFilter(5, 'type');
        _context.handleSetFilterEventDashboard([5, 'type']);
      }
    }
  ];

  return (
    <ul className='EventPageFilters'>
      <li>
        <input
          type="text"
          placeholder='Filter by event name'
          value={searchInput}
          onChange={(e: SyntheticEvent<HTMLInputElement>) => {
            setSearchInput(e.target.value);
          }}
          onKeyPress={(e: SyntheticEvent<HTMLInputElement>) => {
            if (e.charCode === 13) { // Enter keyCode
              setFilter(e.target.value, 'input');
            }
          }}
          autoComplete='off'
        />
      </li>
      <li>
        <Dropdown
          className='EventPageFilters'
          selected={_.find(filters, (f: {}): {} => f.attr['data-id'] === searchType).label}
          item={filters}
        />
      </li>
    </ul>
  );
};

export default EventPageFilters;
